/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { UnitDependencies } from './dependenciesUnitClass.generated';
import { createPlanckMass } from '../../factoriesAny.js';
export var planckMassDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  UnitDependencies: UnitDependencies,
  createPlanckMass: createPlanckMass
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesPlanckMass.generated.js
// module id = 1479
// module chunks = 0